import { render, staticRenderFns } from "./FullScreenModal.vue?vue&type=template&id=513b3d6e&"
import script from "./FullScreenModal.vue?vue&type=script&lang=js&"
export * from "./FullScreenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports